import _ from 'lodash';
function isPropertyEmpty(data) {
    if (_.isArrayLike(data))
        return _.isEmpty(data);
    if (_.isObject(data) && !(data instanceof Date))
        return _.every(data, _.isEmpty);
    return _.isNil(data);
}
export default isPropertyEmpty;
